<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="modal">
  <div class="modal-header">
    <h3>{{ 'add_carrier_dialog.title' | translate }}</h3>
  </div>
  <div class="modal-body">
    <label>
      <span>{{ 'add_carrier_dialog.api_key' | translate }}</span>
      <input type="text" [value]="apiKey" (input)="onApiKeyInput($event)" [placeholder]="'add_carrier_dialog.placeholder_api_key' | translate" />
    </label>
    <div class="helper">
      {{ 'add_carrier_dialog.helper' | translate }}
    </div>
    <div class="error" *ngIf="error">{{ error }}</div>
  </div>
  <div class="modal-footer">
    <button class="button secondary" type="button" (click)="onCancel()" [disabled]="adding">{{ 'add_carrier_dialog.cancel' | translate }}</button>
    <button class="button" type="button" (click)="onSubmit()" [disabled]="adding || !apiKey">{{ 'add_carrier_dialog.continue' | translate }}</button>
  </div>
</div>


